var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      staticClass: "showHeader",
      attrs: {
        visible: _vm.visible,
        direction: "rtl",
        size: "780px",
        "with-header": true,
      },
      on: {
        "update:visible": function ($event) {
          return _vm.$emit("update:visible", $event)
        },
        open: _vm.handleOpen,
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "drawer-title demo-drawer_title",
          attrs: { slot: "title" },
          slot: "title",
        },
        [
          _c("span", [_vm._v("用户 AI 数据详情")]),
          _c(
            "el-button",
            {
              attrs: {
                type: "text",
                size: "mini",
                icon: "el-icon-chat-dot-round",
              },
              on: {
                click: function ($event) {
                  return _vm.$emit("chat")
                },
              },
            },
            [_vm._v("查看聊天记录")]
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "user-detail",
        },
        [
          _c(
            "div",
            { staticClass: "user-detail__profile" },
            [
              _c("el-avatar", { attrs: { size: 48, src: _vm.user.avatar } }, [
                _vm._v(_vm._s((_vm.user.nickname || "用")[0])),
              ]),
              _c("div", { staticClass: "user-detail__profile-info" }, [
                _c("div", { staticClass: "user-detail__name" }, [
                  _vm._v(_vm._s(_vm.user.nickname || "未设置昵称")),
                ]),
                _c("div", { staticClass: "user-detail__meta" }, [
                  _vm._v(
                    "UID：" +
                      _vm._s(_vm.user.uid || _vm.uid) +
                      " · 手机号：" +
                      _vm._s(_vm.user.phone || "-")
                  ),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "user-detail__metrics", attrs: { gutter: 12 } },
            [
              _c("el-col", { attrs: { span: 6 } }, [
                _c("div", { staticClass: "metric-card" }, [
                  _c("div", { staticClass: "metric-card__label" }, [
                    _vm._v("总 token 消耗"),
                  ]),
                  _c("div", { staticClass: "metric-card__value" }, [
                    _vm._v(_vm._s(_vm.formatNumber(_vm.user.totalTokens))),
                  ]),
                ]),
              ]),
              _c("el-col", { attrs: { span: 6 } }, [
                _c("div", { staticClass: "metric-card" }, [
                  _c("div", { staticClass: "metric-card__label" }, [
                    _vm._v("所选时段 token 消耗"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "metric-card__value color-primary" },
                    [_vm._v(_vm._s(_vm.formatNumber(_vm.user.rangeTokens)))]
                  ),
                ]),
              ]),
              _c("el-col", { attrs: { span: 6 } }, [
                _c("div", { staticClass: "metric-card" }, [
                  _c("div", { staticClass: "metric-card__label" }, [
                    _vm._v("AI 会话数"),
                  ]),
                  _c("div", { staticClass: "metric-card__value" }, [
                    _vm._v(
                      _vm._s(_vm.formatNumber(_vm.user.conversationCount))
                    ),
                  ]),
                ]),
              ]),
              _c("el-col", { attrs: { span: 6 } }, [
                _c("div", { staticClass: "metric-card" }, [
                  _c("div", { staticClass: "metric-card__label" }, [
                    _vm._v("最后活跃"),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass:
                        "metric-card__value metric-card__value--small",
                    },
                    [_vm._v(_vm._s(_vm.user.lastActiveTime || "-"))]
                  ),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "user-detail__metrics", attrs: { gutter: 12 } },
            [
              _c("el-col", { attrs: { span: 8 } }, [
                _c("div", { staticClass: "metric-card metric-card--plain" }, [
                  _c("span", { staticClass: "metric-card__label" }, [
                    _vm._v("AI 创建活动"),
                  ]),
                  _c("span", { staticClass: "metric-card__count" }, [
                    _vm._v(
                      _vm._s(_vm.formatNumber(_vm.user.activityCreateCount))
                    ),
                  ]),
                ]),
              ]),
              _c("el-col", { attrs: { span: 8 } }, [
                _c("div", { staticClass: "metric-card metric-card--plain" }, [
                  _c("span", { staticClass: "metric-card__label" }, [
                    _vm._v("AI 创建集市"),
                  ]),
                  _c("span", { staticClass: "metric-card__count" }, [
                    _vm._v(
                      _vm._s(_vm.formatNumber(_vm.user.marketCreateCount))
                    ),
                  ]),
                ]),
              ]),
              _c("el-col", { attrs: { span: 8 } }, [
                _c("div", { staticClass: "metric-card metric-card--plain" }, [
                  _c("span", { staticClass: "metric-card__label" }, [
                    _vm._v("AI 活动报名"),
                  ]),
                  _c("span", { staticClass: "metric-card__count" }, [
                    _vm._v(
                      _vm._s(_vm.formatNumber(_vm.user.activityApplyCount))
                    ),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "user-detail__section" },
            [
              _c("div", { staticClass: "user-detail__section-title" }, [
                _vm._v("按天使用趋势"),
              ]),
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.trend,
                    size: "mini",
                    "max-height": "240",
                    "header-cell-class-name": "tableGrayHeader",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "date", label: "日期", width: "120" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "token 消耗",
                      width: "130",
                      align: "right",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(_vm._s(_vm.formatNumber(scope.row.tokens))),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "创建活动", width: "100", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm.formatNumber(scope.row.activityCreateCount)
                              )
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "创建集市", width: "100", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm.formatNumber(scope.row.marketCreateCount)
                              )
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "活动报名",
                      "min-width": "100",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm.formatNumber(scope.row.activityApplyCount)
                              )
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              !_vm.loading && _vm.trend.length === 0
                ? _c("div", { staticClass: "empty-tip" }, [
                    _vm._v("所选时间范围暂无数据"),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "user-detail__section" },
            [
              _c(
                "div",
                { staticClass: "acea-row row-between-wrapper mb10" },
                [
                  _c("div", { staticClass: "user-detail__section-title" }, [
                    _vm._v("AI 动作明细"),
                  ]),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "140px" },
                      attrs: { size: "mini" },
                      on: { change: _vm.handleActionTypeChange },
                      model: {
                        value: _vm.actionFrom.actionType,
                        callback: function ($$v) {
                          _vm.$set(_vm.actionFrom, "actionType", $$v)
                        },
                        expression: "actionFrom.actionType",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "全部动作", value: "" },
                      }),
                      _c("el-option", {
                        attrs: { label: "创建活动", value: "activity_create" },
                      }),
                      _c("el-option", {
                        attrs: { label: "创建集市", value: "market_create" },
                      }),
                      _c("el-option", {
                        attrs: { label: "活动报名", value: "activity_apply" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.actionLoading,
                      expression: "actionLoading",
                    },
                  ],
                  attrs: {
                    data: _vm.actions,
                    size: "mini",
                    "header-cell-class-name": "tableGrayHeader",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "targetName",
                      label: "活动/集市名称",
                      "min-width": "160",
                      "show-overflow-tooltip": true,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [_vm._v(_vm._s(scope.row.targetName || "-"))]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "动作类型", width: "110", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  size: "mini",
                                  type: _vm.actionTagType(scope.row.actionType),
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.actionTypeText(scope.row.actionType)
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "status",
                      label: "状态",
                      width: "100",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "createTime",
                      label: "时间",
                      width: "160",
                      "show-overflow-tooltip": true,
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "block" },
                [
                  _c("el-pagination", {
                    attrs: {
                      small: "",
                      layout: "total, prev, pager, next",
                      total: _vm.actionTotal,
                      "page-size": _vm.actionFrom.limit,
                      "current-page": _vm.actionFrom.page,
                    },
                    on: { "current-change": _vm.handleActionPageChange },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }